import { Timeline } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import React from 'react';

export const timelineItem = ({ text, color }) => {
  return (
    <Timeline.Item dot={<CheckCircleOutlined style={{ fontSize: '20px', color }} />}>
      {text}
    </Timeline.Item>
  );
};
